import {
  Text,
  Card,
  GreyGrey10,
  GreyGrey40,
  GreyGrey50,
  GreyGrey70,
  GreyWhite,
  IconArrowRight,
  IconBuildings,
  IconSignature,
  Image,
  Primary13Regular,
  Primary13SemiBold,
  Box,
  Flex
} from '@sequencehq/core-components'
import logo from '../attioLogo.svg'
import sequenceLogo from 'modules/Integrations/integrationsConfig/common/sequenceLogo.svg'

const IntegrationPreviewCard = ({
  label,
  logoUrl,
  items = []
}: {
  label: string
  logoUrl: string
  items?: {
    label: string
    icon?: React.ReactNode
  }[]
}) => {
  return (
    <Flex
      backgroundColor={GreyWhite}
      borderRadius="8px"
      border={`1px solid ${GreyGrey40}`}
      boxShadow={'0px 2px 4px 0px rgba(15, 23, 42, 0.08)'}
      minWidth="256px"
      flexDirection="column"
    >
      <Flex
        py="8xp"
        px="12px"
        borderBottom={`1px solid ${GreyGrey40}`}
        width="100%"
        height="32px"
        alignContent="center"
        alignItems="center"
        gap="8px"
      >
        <Image src={logoUrl} height="16px" width="16px" />
        <Text {...Primary13SemiBold}>{label}</Text>
      </Flex>

      <Flex flexDirection="column" gap="8px" p="12px">
        {items.map((item, index) => (
          <Flex
            key={index}
            backgroundColor={GreyGrey10}
            borderRadius="8px"
            height="32px"
            p="8px"
            alignContent="center"
            alignItems="center"
            gap="8px"
          >
            {item.icon ? <Box>{item.icon}</Box> : null}
            <Text {...Primary13Regular}>{item.label}</Text>
          </Flex>
        ))}
      </Flex>
    </Flex>
  )
}

// Readonly and heavily experimental right now. Prone to changes.
export const AttioIntegrationPreviewCard = () => {
  return (
    <Card width="100%">
      <Text {...Primary13SemiBold} mb="8px">
        Preview
      </Text>
      <Flex
        backgroundColor={GreyGrey10}
        borderRadius="8px"
        p="16px"
        alignItems="center"
        alignContent="center"
        justifyContent="space-between"
        gap="0"
        width="100%"
      >
        <IntegrationPreviewCard
          label="Attio"
          logoUrl={logo}
          items={[
            {
              label: 'Create customers'
            },
            {
              label: 'Launch new quotes'
            }
          ]}
        />

        <Flex
          alignItems="center"
          flexGrow={1}
          justifyContent="center"
          width="100%"
          mx="4px"
        >
          <Box
            flex="1"
            height="1.5px"
            backgroundColor={GreyGrey40}
            width="100%"
            borderRadius="8px"
          />

          <Flex
            border={`1px solid ${GreyGrey50}`}
            borderRadius="100%"
            width="32px"
            height="32px"
            boxShadow={'0px 2px 4px 0px rgba(15, 23, 42, 0.08)'}
            justifyContent="center"
            alignItems="center"
            backgroundColor={GreyWhite}
            mx="4px"
          >
            <IconArrowRight />
          </Flex>

          <Box
            flex="1"
            height="1.5px"
            backgroundColor={GreyGrey40}
            width="100%"
            borderRadius="8px"
          />
        </Flex>

        <IntegrationPreviewCard
          label="Sequence"
          logoUrl={sequenceLogo}
          items={[
            {
              icon: <IconBuildings color={GreyGrey70} />,
              label: 'Customers'
            },
            {
              icon: <IconSignature color={GreyGrey70} />,
              label: 'Quotes'
            }
          ]}
        />
      </Flex>
    </Card>
  )
}
